import React, { useContext, useState } from "react";
import "./signupform.css";
import { createUserWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { auth, db, goggleAuthProvider } from "../../firebase.config";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import SvgComponent from "../SvgComponent";
import {
  collection,
  updateDoc,
  doc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { authService } from "../../services/authService";

const SignupForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(true);

  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();

    try {
      await authService.validateOrgUser(email);

      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      const user = userCredential.user;
      dispatch({ type: "SIGNUP", payload: user });

      const orgUserQuery = query(
        collection(db, "org_users"),
        where("email", "==", email)
      );
      const orgUsersSnapshot = await getDocs(orgUserQuery);
      const orgUserDocRef = orgUsersSnapshot.docs[0].ref;

      await updateDoc(orgUserDocRef, {
        user_id: user.uid,
      });

      // once user is signed in navigate them to the home page
      navigate("/");
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log(errorCode, errorMessage);
      setErrorMessage(errorMessage);
    }
  };

  const handleSignUpWithGoggle = async () => {
    try {
      let userCredential = await signInWithPopup(auth, goggleAuthProvider);

      await authService.validateOrgUser(userCredential.user.email);

      const user = userCredential.user;
      dispatch({ type: "SIGNUP", payload: user });

      const orgUsersQuery = query(
        collection(db, "org_users"),
        where("email", "==", user.email)
      );
      const orgUsersSnapshot = await getDocs(orgUsersQuery);
      const orgUserDocRef = orgUsersSnapshot.docs[0].ref;

      await updateDoc(orgUserDocRef, {
        user_id: user.uid,
      });

      // once user is signed in navigate them to the home page
      navigate("/");
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log(errorCode, errorMessage);
      setErrorMessage(errorMessage);
    }
  };

  return (
    <div className="loginContainer">
      <div className="loginFormCard">
        <div className="loginHeader">
          <img src="/X.png" alt="Xeeds.AI Icon" className="loginLogo" />
          <h1 className="text-2xl">Create your account</h1>
        </div>
        <form onSubmit={handleSignup} className="loginForm">
          <div className="inputGroup">
            <input
              type="email"
              name="email"
              id="email"
              placeholder="email"
              value={email}
              className="loginInput"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="inputGroup passwordGroup">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              id="password"
              placeholder="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="loginInput"
              autoComplete="password"
            />
            <button
              type="button"
              className="passwordToggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {!showPassword ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <g
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 5C5.636 5 2 12 2 12s3.636 7 10 7 10-7 10-7-3.636-7-10-7Z" />
                    <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                  </g>
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M20 14.834C21.308 13.332 22 12 22 12s-3.636-7-10-7a8.595 8.595 0 0 0-2 .236M12 9a2.995 2.995 0 0 1 3 3M3 3l18 18m-9-6a2.997 2.997 0 0 1-2.959-2.5M4.147 9c-.308.345-.585.682-.828 1C2.453 11.128 2 12 2 12s3.636 7 10 7c.341 0 .675-.02 1-.058"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </button>
          </div>
          <button type="submit" className="loginButton">
            Continue
          </button>
          {errorMessage.trim() !== " " && (
            <div className="errorMessage">{errorMessage}</div>
          )}
        </form>
        <div className="signupSeparator">OR</div>
        <button
          id="signupWithGoggle"
          className="googleButton"
          onClick={handleSignUpWithGoggle}
        >
          <svg
            className="googleIcon"
            viewBox="0 0 48 48"
            width="20"
            height="20"
          >
            <path
              fill="#FFC107"
              d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
            />
            <path
              fill="#FF3D00"
              d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
            />
            <path
              fill="#4CAF50"
              d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
            />
            <path
              fill="#1976D2"
              d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
            />
          </svg>
          Continue with Goggle
        </button>
        <div className="text-center mt-4">
          <a
            href="/auth/login"
            className="text-sm text-primary-600 hover:text-primary-500"
          >
            Already have an account?{" "}
            <span className=" !text-blue-500">Login here</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SignupForm;
